import { render, staticRenderFns } from "./BlogWithBorder.vue?vue&type=template&id=01d4d51e&scoped=true"
import script from "./BlogWithBorder.vue?vue&type=script&lang=js"
export * from "./BlogWithBorder.vue?vue&type=script&lang=js"
import style0 from "./BlogWithBorder.vue?vue&type=style&index=0&id=01d4d51e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d4d51e",
  null
  
)

export default component.exports